import PropTypes from 'prop-types';
import React from 'react';


class IconPicker extends React.Component {
    static propTypes = {
        items: PropTypes.array.isRequired,
        size: PropTypes.string.isRequired,

        value: PropTypes.number,
        onChange: PropTypes.func
    };

    state = {
        value: this.props.value
    };

    onItemClick = (id) => {
        this.setState({
            value: id
        });

        var { onChange } = this.props;
        if (onChange) onChange(id);
    };

    render() {

        return (

            <div className={Classes('gd-colorpicker', this.props.className, this.props.size)}>

                {this.props.items.map(function(item){

                    var classes = Classes({
                        'item': true,
                        'selected': item.value==this.state.value
                    });

                    var colorClass = Classes({
                        'color': true,
                        [item.label]: true
                    });

                    return (
                        <div className={classes} key={item.value} onClick={this.onItemClick.bind(this, item.value)} >
                            <div className={colorClass} ></div>
                        </div>
                    )
                }.bind(this))}
                <div className="cf"></div>
            </div>

        );
    }
}

module.exports = IconPicker;